<template>
  <div>
    <div class="px-5 md:px-0">
      <p class="font-display text-2xl font-bold mb-4 text-gray-900">{{ $t('competitions') }}</p>
      <div class="flex flex-col gap-3 md:flex-row md:items-center justify-start md:px-0">
        <button
          @click="$router.push('/' + Language + '/competitions')"
          class="font-body text-base text-white flex items-center gap-1 bg-blue rounded-full px-3 py-1 w-fit"
        >
          <img
            src="../../assets/img/back-arrow.svg"
            class="h-3 w-4 inline"
          > {{ $t('back').tTitle() }}
        </button>
        <h3 class="text-blue text-xl font-medium">{{ competition.name }}</h3>
      </div>
    </div>
    <div class="mx-3 md:mx-0 bg-white px-4 py-4 rounded-lg mt-8">
      <div class="inline-grid grid-cols-1 grid-rows-4 gap-2 md:grid-rows-2 md:grid-cols-2 xl:grid-cols-4 xl:grid-rows-1 w-full">
        <StatisticsCards
          v-for="statistic in statisticsCards"
          :key="statistic.id"
          :item="statistic"
          :large="true"
        />
      </div>
    </div>
    <div class="mx-3 md:mx-0 mt-3 grid grid-cols-1 gap-3 lg:grid-cols-2 mb-28">
      <div class="bg-white p-5 rounded-lg">
        <h3 class="title">{{ $t('choose_platform') }}</h3>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <div
            @click="selectedPlatform = 'mt4'"
            class="pt-6 pb-4 xl:pt-12 xl:pb-8 border border-gray-500 rounded-lg cursor-pointer flex items-center justify-center"
            :class="{ '!border-blue': selectedPlatform == 'mt4' }"
          >
            <div>
              <img
                src="../../assets/img/icons/competitions/mt-4.svg"
                width="120"
                alt=""
              >
              <h3 class="text-blue font-semibold pt-10 text-base text-center">{{ $t('mt4_platform') }}</h3>
            </div>
          </div>
          <div
            @click="selectedPlatform = 'mt5'"
            class="pt-6 pb-4 xl:pt-12 xl:pb-8 border border-gray-500 rounded-lg cursor-pointer flex items-center justify-center"
            :class="{ '!border-blue': selectedPlatform == 'mt5' }"
          >
            <div>
              <img
                src="../../assets/img/icons/competitions/mt-5.svg"
                width="120"
                alt=""
              >
              <h3 class="text-blue font-semibold pt-10 text-base text-center">{{ $t('mt5_platform') }}</h3>
            </div>
          </div>
        </div>
        <button
          @click="enterCompetition"
          :disabled="selectedPlatform == ''"
          :class="{ '!bg-gray-500': selectedPlatform == '' }"
          class="w-40 !mt-4 text-center text-white bg-green text-base font-bold rounded-md py-3 px-3 md:mt-5 lg:mt-0 table lg:block"
        >{{
            $t('submit').tTitle() }}</button>
      </div>
      <div class="bg-white p-5 rounded-lg">
        <!-- Prizes -->
        <div class="mb-3">
          <h3 class="title">{{ $t('prizes') }}</h3>
          <div
            class="flex pt-[21px] gap-x-4 overflow-x-auto custom-scrollbar pb-3 scroll-smooth select-none"
            id=prizesContainer
          >
            <div
              v-for="(prize, i) in prizes"
              :key="i"
            >
              <div class="w-[100px] h-[125px] border border-gray-500 rounded-2xl relative">
                <div class="absolute w-full -top-[20px] flex justify-center">
                  <img
                    :src="prize.icon"
                    width="40"
                    height="40"
                    :alt="prize.title"
                  >
                </div>
                <div class="pt-8 px-4">
                  <h5 class="text-xs text-gray-900 text-center">{{ prize.title }}</h5>
                  <h2
                    class="text-base text-center font-semibold"
                    :class="'text-' + prize.color"
                  >${{
                    prize.amount }}</h2>
                  <h3 class="text-[10px] text-gray-600 text-center">{{ prize.text }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Rules -->
        <div>
          <h3 class="title">{{ $t('comp_rules') }}</h3>
          <Rules />
        </div>
      </div>
    </div>
    <Modal
      :opened="showModal"
      @close="showModal = false"
    >
      <div class="w-11/12 lg:w-[442px] max-w-[442px] flex flex-col items-center">
        <img
          :src="modalIcon"
          width="90"
          height="90"
          alt="enter competition"
        >
        <p
          class="text-gray-900 text-4xl font-semibold pt-4 text-center flex justify-center"
          v-html="modalTitle"
        ></p>
        <p
          v-if="modalText"
          class="text-gray-900 text-base pt-3"
          v-html="modalText"
        ></p>
        <button
          v-if="modalTitle == $t('enter_comp_success')"
          class="py-3 h-full bg-blue rounded-md text-white appearance-none font-medium mt-5 text-base text-center w-44 ltr:float-left rtl:float-right cursor-pointer"
        >
          <router-link :to="'/' + Language + '/competitions'">{{ $t('go_to_competitions') }}</router-link></button>
        <button
          v-else
          @click="showModal = false"
          class="py-3 h-full bg-blue rounded-md text-white appearance-none font-medium mt-5 text-base text-center w-40 ltr:float-left rtl:float-right cursor-pointer"
        >
          {{ $t('go_back') }}</button>
      </div>
    </Modal>
    <Modal
      :opened="openCountryModal"
      @close="openCountryModal = false"
    >
      <div class="flex flex-col items-center">
        <img
          src="../../assets//img/icons/competitions/try-again.svg"
          width="90"
          height="90"
          alt="enter competition"
        >
        <p class="text-gray-900 text-4xl font-semibold pt-4 text-center flex justify-center">{{ $t('unav_competition') }}</p>
        <p class="text-gray-900 text-base text-center pt-3">{{ $t('us_restricted') }}</p>
        <button class="py-3 h-full bg-blue rounded-md text-white appearance-none font-medium mt-5 text-base text-center w-40 ltr:float-left rtl:float-right cursor-pointer">
          <router-link :to="'/' + Language + '/competitions'">{{ $t('go_to_competitions') }}</router-link></button>
      </div>
    </Modal>
  </div>

</template>

<script>
import moment from 'moment';
import StatisticsCards from './shared-components/StatisticsCards.vue';
import Rules from './shared-components/Rules.vue';
import Modal from '@/components/reusableComponents/Modal.vue';

import { service } from '@/main';
import { mapActions, mapGetters } from 'vuex';
import config from '../../config'

export default {
  name: 'enter-competition',
  components: { StatisticsCards, Rules, Modal },
  data() {
    return {
      competition: {},
      statisticsCards: [
        { id: 'comp_start', title: "", icon: require('@/assets/img/icons/competitions/time-remaining.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '' },
        { id: 'comp_end', title: "", icon: require('@/assets/img/icons/competitions/current-leader.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '' },
        { id: 'reg_end', title: "", icon: require('@/assets/img/icons/competitions/registration-ends.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '' },
        { id: 'contestants', title: "", icon: require('@/assets/img/icons/competitions/contestants.svg'), statisticTime: '', statisticValueDate: '', statisticValueNumber: '' }
      ],
      prizes: [],
      selectedPlatform: "",
      showModal: false,
      modalTitle: '',
      modalIcon: '',
      modalText: '',
      openCountryModal: false
    }
  },
  mounted() {
    if (this.$route.query.competition) {
      this.competition = JSON.parse(this.$route.query.competition)
      this.$router.replace({ 'query': null });
      this.populateStatisticsCards()
      this.populatePrizes()
    } else {
      this.$router.push('/' + this.Language + '/competitions')
    }
    this.dragContainer('#prizesContainer')
  },
  watch: {
    Language() {
      this.populateStatisticsCards()
      this.populatePrizes()
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: "language/code"
    })
  },
  methods: {
    populateStatisticsCards() {
      this.statisticsCards.map((statistic) => {
        switch (statistic.id) {
          case 'comp_start':
            statistic.title = this.$t('comp_starts')
            statistic.statisticTime = moment(this.competition.start_date).format('LT')
            statistic.statisticValueDate = moment(this.competition.start_date).format('LL')
            break;
          case 'comp_end':
            statistic.title = this.$t('comp_ends')
            statistic.statisticTime = moment(this.competition.end_date).format('LT')
            statistic.statisticValueDate = moment(this.competition.end_date).format('LL')
            break;
          case 'reg_end':
            statistic.title = this.$t('reg_ends')
            statistic.statisticValueDate = moment().date(15).format('LL')
            break;
          case 'contestants':
            statistic.title = this.$t('contestants')
            statistic.statisticValueNumber = this.competition.contestants_count
            break;
        }
      })
    },
    populatePrizes() {
      if (this.competition.prizes) {
        let prizes = []
        this.competition.prizes.map((prize, i) => {
          let prizeObject = {
            amount: prize,
            text: this.$t('credited_live')
          }
          switch (i) {
            case 0:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize1.svg`),
                prizeObject.title = this.$t('first_place')
              prizeObject.color = 'green'
              break
            case 1:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize2.svg`),
                prizeObject.title = this.$t('second_place')
              prizeObject.color = 'blue'
              break
            case 2:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize3.svg`),
                prizeObject.title = this.$t('third_place')
              prizeObject.color = 'gold'
              break
            case 3:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize4.svg`),
                prizeObject.title = this.$t('fourth_place')
              prizeObject.color = 'gray-900'
              break
            case 4:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('fifth_place')
              prizeObject.color = 'gray-600'
              break
            case 5:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('sixth_place')
              prizeObject.color = 'gray-600'
              break
            case 6:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('seventh_place')
              prizeObject.color = 'gray-600'
              break
            case 7:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('eitth_place')
              prizeObject.color = 'gray-600'
              break
            case 8:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('nineth_place')
              prizeObject.color = 'gray-600'
              break
            case 9:
              prizeObject.icon = require(`@/assets/img/icons/competitions/prize5.svg`),
                prizeObject.title = this.$t('tenth_place')
              prizeObject.color = 'gray-600'
              break
          }
          prizes.push(prizeObject)
        })
        this.prizes = prizes
      }
    },
    async enterCompetition() {
      if (!config.eligibleCountriesTradingCompetition.includes(this.User.info.country_code)) {
        // this['logoLoader/set'](true);
        try {
          const response = await service.post('/trading-competition/join', {
            platform: this.selectedPlatform,
            userId: JSON.stringify(this.User.info.ID),
            competition_id: JSON.stringify(this.competition.id)
          });
          if (response && response.data) {
            this['competition/setHasEnteredCompetition'](true)
            this.modalTitle = this.$t('enter_comp_success')
            this.modalText = this.$t('enter_comp_success_text', { contactUrl: 'https://www.plexytrade.com/contact/' })
            this.modalIcon = require('@/assets/img/icons/competitions/successful.svg')
            // this['logoLoader/set'](false)
            this.showModal = true
          } else if(response.meta && response.meta['messageID']) {
            this.modalTitle = this.$t(response.meta['messageID'])
            this.modalIcon = require('@/assets/img/icons/competitions/try-again.svg')
            this.showModal = true
            // this['logoLoader/set'](false)
            this.showModal = true
          } else {
            this.modalTitle = this.$t('enter_comp_error')
            this.modalIcon = require('@/assets/img/icons/competitions/try-again.svg')
            this.showModal = true
            // this['logoLoader/set'](false)
          }
        } catch (err) {
          if(err.response && err.response.data) {
            let response = err.response.data
            if(response.meta && response.meta['messageID']) {
              this.modalTitle = this.$t(response.meta['messageID'])
              this.modalIcon = require('@/assets/img/icons/competitions/try-again.svg')
              this.showModal = true
              this['logoLoader/set'](false)
            } else {
              this.modalTitle = this.$t('enter_comp_error')
              this.modalIcon = require('@/assets/img/icons/competitions/try-again.svg')
              this.showModal = true
              this['logoLoader/set'](false)
            }
          }
        }
      } else {
        this.openCountryModal = true
      }
    },
    ...mapActions(['logoLoader/set', 'competition/setHasEnteredCompetition']),
  },

}
</script>
<style scoped>
.title {
  @apply text-lg text-gray-900 font-semibold pb-4;
}

@media screen and (max-width: 650px) {
  #prizesContainer::-webkit-scrollbar {
    display: none;
  }
}
</style>
